module.exports = __webpack_public_path__ + "static/media/doc.6c54ede2.svg";